
import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../Pages/Newhomepage.css';
import banphone from '../Pages/Newimages/banner-phone.png';
import sidephone from '../Pages/Newimages/sidephone.png';
import aws from '../Pages/Newimages/aws.png';
import zoho from '../Pages/Newimages/zoho.png';
import surya from '../Pages/Newimages/surya.png';
import csb from '../Pages/Newimages/csb.png';
import digital from '../Pages/Newimages/digital.png';
import axis from '../Pages/Newimages/axis.png';
import open from '../Pages/Newimages/open.png';
import stat from '../Pages/Newimages/stat.png';
import time from '../Pages/Newimages/time.png';
import circle from '../Pages/Newimages/circle.png';
import thunder from '../Pages/Newimages/thunder.png';
import empowering from '../Pages/Newimages/empowering.png';
import lap from '../Pages/Newimages/laptop.png';
import playbtn from '../Pages/Newimages/playbtn.png';
import applebtn from '../Pages/Newimages/applebtn.png';
import newplaystore from '../Pages/Newimages/newplaystore.png';
import img1 from '../Images/features/img1.png';
import img2 from '../Images/features/img2.png';
import img3 from '../Images/features/img3.png';
import img4 from '../Images/features/img4.png';
import Newnavbar from '../Pages/Newnavbar';
import Newfooter from '../Pages/Newfooter';

const Features = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            easing: 'ease-in-out',
            once: false,
        });
    }, []);

    return (
        <>
            <Newnavbar />

        <div className="new_ui_all">
            <div className="banner_img !py-5">
                <div className="!flex !flex-row !container !mx-auto !py-5">
                    <div className="!w-[70%] !mx-auto">
                        <div className="new_ban_des !flex !justify-center !flex-col">
                            <h2 className="!text-center md:!text-[42px] !text-[20px]">
                                Smart Features That Simplify <span className="">Your Finances</span>
                            </h2>
                            <p className="!text-center">
                                Explore smart, secure tools designed to simplify every aspect of your financial life. From expense tracking to team collaboration — manage it all in one place.
                            </p>
                            <button className="!w-fit !mx-auto" type="button">
                                Get Started 
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                    <path d="M11.666 19.8334L17.4993 14L11.666 8.16669" stroke="black" stroke-width="2.33377" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="trust_companies !mx-auto !px-4 !py-8">
                <h2 className="!text-center md:!text-[32px] !text-[20px] !font-semibold !mb-6">
                    Trusted and Partnered with Leading Institutions
                </h2>
                {/* Desktop View */}
                <div className="!hidden md:!flex !space-x-6 !mx-auto !w-fit">
                    {[zoho, aws, axis, digital, csb, open, surya, open].map((src, i) => (
                        <img
                            key={i}
                            src={src}
                            alt="Partner Logo"
                            className="!w-[100px] !h-[100px] !object-contain"
                        />
                    ))}
                </div>
                {/* Mobile/Tablet Carousel */}
                <div className="!block md:!hidden !overflow-hidden !relative !w-full">
                    <div className="!flex !w-max !animate-scroll-left !space-x-6">
                        {[...Array(2)].flatMap(() =>
                            [zoho, aws, axis, digital, csb, open, surya, open].map((src, i) => (
                                <img
                                    key={`${src}-${i}`}
                                    src={src}
                                    alt="Partner Logo"
                                    className="!w-[100px] !h-[100px] !object-contain"
                                />
                            ))
                        )}
                    </div>
                </div>
            </div>
    
            <div className=" md:!py-[40px] !py-[30px] md:!px-[0px] !px-[16px] space-y-[40px]">
                {/* Real Time Expense Tracking Section */}
                <section className="max-w-7xl mx-auto ">
                    <h2 className="md:!text-[36px] !text-[24px] font-bold text-gray-900 mb-[20px] text-start text_glow">Real Time Expense Tracking</h2>
                    <div className="flex flex-col md:flex-row items-center md:items-start gap-12">
                        <div className="w-full md:w-1/2 flex justify-center">
                            <img
                                src={img1}
                                alt="Person using calculator and phone"
                                className="rounded-lg shadow-lg"
                            />
                        </div>
                        <div className="w-full md:w-1/2 grid gap-[12px]">
                            <FeatureCard
                                number="1"
                                title="Instant Capture"
                                description="No more waiting for monthly reports or chasing receipts. Expenses are tracked the moment they happen Works for team purchases, vendor payments, and recurring bills"
                            />
                            <FeatureCard
                                number="2"
                                title="Full Financial Visibility"
                                description="Real-time tracking ensures no lag in reporting. Every rupee is accounted for instantly. Supports better budgeting, fraud detection, and decision-making"
                            />
                            <FeatureCard
                                number="3"
                                title="Real Time Notifications"
                                description="Get alerts the moment a transaction happens. Works for online payments, card swipes, and bill uploads. Keeps you in control of company spending 24/7"
                            />
                            <FeatureCard
                                number="4"
                                title="Eliminate Manual Errors"
                                description="Manual expense tracking is outdated and risky. Removes the need for spreadsheets or paper receipts. Minimizes human error and delays."
                            />
                        </div>
                    </div>
                </section>
                {/* Fast Seamless Payments Section */}
                <section className="max-w-7xl mx-auto">
                    
                    <h2 className="md:!text-[36px] !text-[24px] font-bold text-gray-900 mb-[20px] text-start text_glow">Fast Seamless Payments</h2>
                    <div className="flex flex-col md:flex-row-reverse items-center md:items-start gap-12">
                        <div className="w-full md:w-1/2 flex justify-center">
                            <img
                                src={img2}
                                alt="Person making payment with card reader"
                                className="rounded-lg shadow-lg"
                            />
                        </div>
                        <div className="w-full md:w-1/2 grid gap-[12px]">
                            <FeatureCard
                                number="1"
                                title="One Click Payments"
                                description="Pay invoices directly from uploaded documents. Pre-filled details from your expense records. Save time, reduce manual entry"
                            />
                            <FeatureCard
                                number="2"
                                title="Smart Approvals"
                                description="Auto-approve recurring or low-value expenses. Route high-value payments through multiple approvers. Instant push notifications to speed up approvals"
                            />
                            <FeatureCard
                                number="3"
                                title="Cross Platform Access"
                                description="Whether you’re in the office or on the move, Paybi ensures you can make and approve payments anytime, from any device."
                            />
                        </div>
                    </div>
                </section>
                {/* Categorised Expenses Section */}
                <section className="max-w-7xl mx-auto mb-20">
                   
                    <h2 className="md:!text-[36px] !text-[24px] font-bold text-gray-900 mb-[20px] text-start text_glow">Categorised Expenses</h2>
                    <div className="flex flex-col md:flex-row items-center md:items-start gap-12">
                        <div className="w-full md:w-1/2 flex justify-center">
                            <img
                                src={img3}
                                alt="Person writing on a document"
                                className="rounded-lg shadow-lg"
                            />
                        </div>
                        <div className="w-full md:w-1/2 grid gap-[12px]">
                            <FeatureCard
                                number="1"
                                title="Real Time Insights"
                                description="No more sifting through Excel files or waiting for your finance team. With PayBi, all categorized expenses are visible in a clean, visual dashboard."
                            />
                            <FeatureCard
                                number="2"
                                title="Smarter Financial Decisions"
                                description="PayBi empowers smarter spending with tools that ensure budget adherence, prevent fraud, and offer clear cost analysis."
                            />
                            <FeatureCard
                                number="3"
                                title="Mobile Tracking Made Easy"
                                description="Snap and upload receipts effortlessly, with expenses automatically categorized for smarter, faster tracking."
                            />
                        </div>
                    </div>
                </section>
                {/* Detailed Spending Reports Section */}
                <section className="max-w-7xl mx-auto mb-20">
                    <h2 className="md:!text-[36px] !text-[24px] font-bold text-gray-900 mb-[20px] text-start text_glow">Detailed Spending Reports</h2>
                    <div className="flex flex-col md:flex-row-reverse items-center md:items-start gap-12">
                        <div className="w-full md:w-1/2 grid gap-[12px]">
                            <FeatureCard
                                number="1"
                                title="Secure & Compliant Reporting"
                                description="All reports are encrypted, time-stamped, and stored with enterprise-grade security. PCI-DSS & ISO standards"
                            />
                            <FeatureCard
                                number="2"
                                title="Secure & Compliant Reporting"
                                description="All reports are encrypted, time-stamped, and stored with enterprise-grade security."
                            />
                            <FeatureCard
                                number="3"
                                title="AI-Powered Recommendations"
                                description="PayBi’s smart reporting do more than just show data. Get AI-driven suggestions on where to cut costs"
                            />
                        </div>
                        <div className="w-full md:w-1/2 flex justify-center">
                            <img
                                src={img4}
                                alt="Person looking at documents and calculator"
                                className="rounded-lg shadow-lg"
                            />
                        </div>
                    </div>
                </section>
            </div>
            <Newfooter />
        </div>
        </>
    );
};

function FeatureCard({ number, title, description }) {
    return (
        <div className="flex item-center !gap-x-[30px] !bg-white !rounded-[12px] !py-[20px] !px-[40px] !shadow-md">
            <div className="flex-shrink-0 mr-4 !my-auto ">
                <div className="!my-auto ">
                    <p className='text-[36px] !font-bold'>{number}</p>
                </div>
            </div>
            <div>
                <h3 className="!text-[22px] !font-bold !text-[#1A1A1A]">{title}</h3>
                <p className="!text-[14px] !text-[#525252] !font-medium">{description}</p>
            </div>
        </div>
    );
}

export default Features;
